<template>
  <div>
    <b-input-group class="autocomplete-input-group">
      <b-form-input
        id="input-worker-status"
        size="sm"
        :disabled="isDisabled"
        v-model="query"
        :placeholder="items.length === 0 ? 'Создайте статус исполнителя' : 'Выберите статус исполнителя'"
        autocomplete="off"
        class="autocomplete-input-group"
        @focus="onFocusIn"
        @blur="onFocusOut"
      />

      <b-input-group-append>
        <b-button size="sm" :disabled="!query || isDisabled" @click="onClear">
          <font-awesome-icon icon="times-circle"/>
        </b-button>
        <b-button
            v-if="canCreateCatalog()"
            size="sm"
            variant="success"
            :disabled="isDisabled"
            @click="showModalCatalog"
            v-b-tooltip.hover.v-success
            title="Создать статус исполнителя"
        >
          <font-awesome-icon icon="plus"/>
        </b-button>
      </b-input-group-append>

      <b-list-group class="autocomplete-worker-status" v-if="isFocus" :class="{ 'dropUp': dropUp }">
        <b-list-group-item
          v-for="(item, index) in items"
          :key="index"
          @mousedown="onClick(item)"
          button
        >
          {{ getItemListText(item) }}
        </b-list-group-item>
        <b-list-group-item v-if="items.length === 0 && query" disabled>
          <small>Ничего не найдено</small>
        </b-list-group-item>
      </b-list-group>
    </b-input-group>

    <worker-status
      v-if="isModalVisible"
      :exact-id="0"
      @modal-closed="isModalVisible = false"
      @refresh="onWorkerStatusCreated"
    />

  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
import permissions, {PERM} from "../../../utilites/permissions";
import WorkerStatus from "./WorkerStatus.vue";

export default {
  name: "WorkerStatusSelect",
  components: { WorkerStatus },
  mixins: [
    catalogs,
    permissions,
  ],
  props: {
    isDisabled: { type: Boolean },
    id: { type: Number },
    dropUp: { type: Boolean, default: false }
  },
  data() {
    return {
      isFocus: false,
      query: "",
      items: [],
      item: null,
      isModalVisible: false
    }
  },
  methods: {
    async configure(id) {
      this.query = "";

      if (id > 0) {
        const workerStatus = (await this.getWorkerStatusById(id)).data;
        if (workerStatus != null) {
          this.query = workerStatus.name;
          this.item = workerStatus;
          return;
        }
      }

      this.items = await this.getItems(this.query);
    },
    async onFocusIn() {
      if (this.query === "" && this.items.length === 0) {
        this.items = await this.getItems(this.query);
      }
      this.isFocus = true;
    },
    onFocusOut() {
      this.isFocus = false;

      if (this.item) {
        if (this.query !== this.item.name) {
          this.query = this.item.name;
        }
      } else {
        this.query = "";
      }
    },
    onClear() {
      this.query = "";
      this.item = null;
      this.$emit('onSelect',null);
    },
    onClick(item) {
      this.query = item.name;
      this.item = item;
      this.$emit('onSelect', item);
    },
    getItemListText(item) {
      return item.name;
    },
    async getItems(query) {
      const result = await this.getWorkerStatusesSearch(query);
      if (result.data != null) {
        return result.data;
      } else {
        return [];
      }
    },
    showModalCatalog() {
      this.isModalVisible = true;
    },
    async onWorkerStatusCreated(newItem) {
      this.items.push(newItem);
      this.onClick(newItem);
      this.isModalVisible = false;
    },
    // Permissions
    canCreateCatalog() {
      return this.hasPermission([PERM.CATALOG_WORKER_STATUS_EDIT]);
    }
  },
  watch: {
    'id': {
      handler(newId, oldId) {
        if (newId !== oldId) {
          this.configure(newId);
        }
      }, immediate: true
    },
    'query': {
      handler: async function () {
        if (this.query != null) {
          const queryLower = this.query.toLowerCase();
          this.items = await this.getItems(queryLower);
        }
      }, deep: true
    },
  }
}
</script>

<style scoped>
/* Autocomplete Select Input */
.autocomplete-worker-status {
  margin-top: 31px;
  max-height: 250px;
  overflow-y: auto;
  position: absolute;
  z-index: 1030;
  text-align: left;
}

.autocomplete-input-group {
  position: unset;
}

/* Autocomplete Select Input Group Item */
.autocomplete-worker-status .list-group-item {
  padding: 0.5rem 1rem;
}

.autocomplete-worker-status.dropUp {
  top: auto;
  bottom: 55%;
  margin-top: 0;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkerStatuses/WorkerStatusSelect.vue